<template>
    <div class="bg">
        <div class="wrap">

            <div class="info-wrap">
                <div class="deny-wrap" v-if="denyReason!=''">
                    <span class="deny-reason">{{denyReason}}</span>
                </div>
                <div class="item-wrap">
                    <span class="title">{{title_1}}</span>
                    <div class="item">
                        <span>姓名</span>
                        <input type="text" v-model="data.info_name">
                    </div>
                    <div class="item">
                        <span>性别</span>
                        <input type="text" v-model="data.info_gender" readonly @click="genderSelect">
                        <label></label>
                    </div>

                    <div class="item">
                        <span>就诊</span>
                        <input type="text" v-model="data.info_diagnose" readonly @click="diagnoseSelect">
                        <label></label>
                    </div>
                </div>
                <div class="item-wrap space">

                    <span class="title">{{title_2}}</span>

                    <div class="item">
                        <span>现病史</span>
                        <input type="text" v-model="data.his_now">
                    </div>

                    <div class="item">
                        <span>既往史</span>
                        <input type="text" v-model="data.his_old" readonly @click="oldSelect">
                        <label></label>
                    </div>

                    <div class="item" v-if="data.his_old!=null&&(data.his_old!=''&&data.his_old!='无'&&data.his_old!='其他')">
                        <span >既往史时间</span>
                        <div>
                            <input type="text" v-model="data.his_old_time" readonly  @click="oldTimeSelect">
                        </div>
                        <label></label>
                    </div>

                    <div class="item" v-if="data.his_old=='其他'">
                        <span>其他既往史</span>
                        <input type="text" v-model="data.his_old_other">
                    </div>

                    <div class="item">
                        <span>家族史</span>
                        <input type="text" v-model="data.his_family" readonly @click="familySelect">
                        <label></label>
                    </div>

                    <div class="item" v-if="data.his_family!=null&&(data.his_family!=''&&data.his_family!='无'&&data.his_family!='其他')">
                        <span >家族史时间</span>
                        <div>
                            <input type="text" v-model="data.his_family_time" readonly  @click="familyTimeSelect">
                        </div>
                        <label></label>
                    </div>

                    <div class="item" v-if="data.his_family=='其他'">
                        <span>其他家族史</span>
                        <input type="text" v-model="data.his_family_other">
                    </div>

                    <span style="margin-top: 10px ">主诉</span>
                    <div class="demand-wrap">
                    <textarea v-model="data.his_demand">

                    </textarea>
                    </div>
                </div>

            </div>

            <div class="next">
                <span @click="toNext">{{next}}</span>
            </div>

            <mt-popup class="popup" v-model="popupVisible" popup-transition="popup-fade" closeOnClickModal="true"
                      position="bottom">
                <mt-picker :slots="slots" @change="slotValueChange" showToolbar>
                    <div class="picker-toolbar-title">
                        <div class="usi-btn-cancel" @click="popupVisible = !popupVisible">取消</div>
                        <div class="">请选择</div>
                        <div class="usi-btn-sure" @click="slotValueAdd">确定</div>
                    </div>
                </mt-picker>
            </mt-popup>

        </div>
    </div>

</template>

<script>
    import {addCase, getCase} from "@/assets/js/api";
    import {Indicator} from "mint-ui";

    export default {
        name: 'HelloWorld',
        data() {
            return {
                title_1: "1、患者一般资料",
                title_2: "2、病史信息",
                title_3: "方案",
                denyReason:"",
                data: {
                    info_name: "",
                    info_gender: "",
                    info_diagnose: "",
                    his_demand: "",
                    his_old: "",
                    his_old_time:"",
                    his_old_other:"",
                    his_now: "",
                    his_family: "",
                    his_family_time:"",
                    his_family_other:"",
                    caseId: this.$store.state.caseId,
                    docId: this.$store.state.docId,
                    scheme:this.$route.query.scheme,
                },

                genderVisible: true,
                slots: [
                    {
                        values: [],
                    }
                ],
                slotSure: "",
                slotTag: 0,
                popupVisible: false,
                next: "下一步 >",
                editStation:0
            }
        },
        methods: {
            async toNext() {

                if(this.editStation==1){ //审核通过的,直接通过不允许修改了
                    this.toData();//进入下一步
                    return
                }

                if (this.data.info_name == "") {
                    this.$toast("请填写姓名")
                    return
                }
                if (this.data.info_gender == "") {
                    this.$toast("请选择性别")
                    return
                }
                if (this.data.info_diagnose == "") {
                    this.$toast("请选择就诊")
                    return
                }
                if (this.data.his_demand == "") {
                    this.$toast("请填写主诉")
                    return
                }
                if (this.data.his_now == "") {
                    this.$toast("请填写现病史")
                    return
                }
                if (this.data.his_old == "") {
                    this.$toast("请选择既往史")
                    return
                }
                if (this.data.his_family == "") {
                    this.$toast("请选择家族史")
                    return
                }


                if(this.data.his_old!="无"&&this.data.his_old!='其他'&&(this.data.his_old_time==""||this.data.his_old_time==null)){
                    this.$toast("请选择既往史时间")
                    return
                }

                if(this.data.his_old=='其他'&&(this.data.his_old_other==""||this.data.his_old_other==null)){
                    this.$toast("请填写其他既往史")
                    return
                }

                if(this.data.his_family!="无"&&this.data.his_family!='其他'&&(this.data.his_family_time==""||this.data.his_family_time==null)){
                    this.$toast("请选择家族史时间")
                    return
                }

                if(this.data.his_family=='其他'&&(this.data.his_family_other==""||this.data.his_family_other==null)){
                    this.$toast("请填写其他家族史")
                    return
                }

                if(this.data.his_old=="无"){
                    this.data.his_old_time = "";
                    this.data.his_old_other = "";
                }
                if(this.data.his_old!="无"&&this.data.his_old!='其他'){
                    this.data.his_old_other = "";
                }
                if(this.data.his_old=='其他'){
                    this.data.his_old_time = ""
                }

                if(this.data.his_family=="无"){
                    this.data.his_family_time = "";
                    this.data.his_family_other = "";
                }
                if(this.data.his_family!="无"&&this.data.his_family!='其他'){
                    this.data.his_family_other = "";
                }
                if(this.data.his_family=='其他'){
                    this.data.his_family_time = ""
                }


                let data = this.data

                console.log(data,"data=")


                Indicator.open({
                    text: '上传中',
                    spinnerType: 'fading-circle'
                });
                let res = await addCase({data})
                if (res.data.success == true) {
                    Indicator.close()
                    this.$store.state.caseId = res.data.data
                    this.toData();//进入下一步
                } else {
                    this.$toast(res.data.message)
                }
            },
            toData() {
                this.$router.push({path: "caseData",query:{scheme:this.$route.query.scheme}})
            },
            genderSelect() {
                this.popupVisible = true
                this.slots[0].values = ['男', '女']
                this.slotTag = 1
            },
            diagnoseSelect() {
                this.popupVisible = true
                this.slots[0].values = ['初诊', '复诊']
                this.slotTag = 2
            },
            oldSelect() {
                this.popupVisible = true
                this.slots[0].values = ['无', '糖尿病史', '脂肪肝史','高血压史',"其他"]
                this.slotTag = 3
            },
            familySelect() {
                this.popupVisible = true
                this.slots[0].values = ['无', '糖尿病史', '脂肪肝史','高血压史',"其他"]
                this.slotTag = 4
            },

            oldTimeSelect() {
                this.popupVisible = true
                this.slots[0].values = ['0-1年','1-3年', '3-5年', '5年以上']
                this.slotTag = 5
            },

            familyTimeSelect() {
                this.popupVisible = true
                this.slots[0].values = ['1-3年', '3-5年', '5年以上']
                this.slotTag = 6
            },


            slotValueChange(picker, values) {
                this.slotSure = values[0];
            },
            slotValueAdd() {
                this.popupVisible = !this.popupVisible
                switch (this.slotTag) {
                    case 1:
                        this.data.info_gender = this.slotSure;
                        break;
                    case 2:
                        this.data.info_diagnose = this.slotSure;
                        break;
                    case 3:
                        this.data.his_old = this.slotSure;
                        if(this.slotSure=="无"){
                            this.data.his_old_time=null
                        }
                        break;
                    case 4:
                        this.data.his_family = this.slotSure;
                        if(this.slotSure=="无"){
                            this.data.his_family_time=null
                        }
                        break;
                    case 5:
                        this.data.his_old_time = this.slotSure;
                        break;
                    case 6:
                        this.data.his_family_time = this.slotSure;
                        break;
                }
            },
            async getCase(caseId) {
                let res = await getCase({caseId})

                console.log(res,"res------")

                this.data.info_name = res.data.data.info_name==null?"":res.data.data.info_name
                this.data.info_gender = res.data.data.info_gender==null?"":res.data.data.info_gender
                this.data.info_diagnose = res.data.data.info_diagnose==null?"":res.data.data.info_diagnose
                this.data.his_demand = res.data.data.his_demand==null?"":res.data.data.his_demand
                this.data.his_old = res.data.data.his_old==null?"":res.data.data.his_old
                this.data.his_old_time = res.data.data.his_old_time==null?"":res.data.data.his_old_time
                this.data.his_old_other = res.data.data.his_old_other==null?"":res.data.data.his_old_other
                this.data.his_now = res.data.data.his_now==null?"":res.data.data.his_now
                this.data.his_family = res.data.data.his_family==null?"":res.data.data.his_family
                this.data.his_family_time = res.data.data.his_family_time==null?"":res.data.data.his_family_time
                this.data.his_family_other = res.data.data.his_family_other==null?"":res.data.data.his_family_other

                this.editStation = res.data.data.sys_station

                this.denyReason = res.data.data.sys_check_reason

            }
        },
        mounted() {
            this.getCase(this.data.caseId);
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .bg{
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
    }

    .wrap {
        width: 100%;
        max-width: 400px;
        height: 100vh;
        background: #FFF;
    }

    .item-wrap {
        width: 95%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: start;
        font-size: 20px;
        text-align: left;
        text-indent: 10px;


        .title {
            width: 100%;
            background: #0082C5;
            color: #FFF;
            font-size: 22px;
            border-radius: 5px;
            margin-top: 20px;
            padding: 5px 0;
        }

        .item {
            width: 100%;
            background: #D0E6F4;
            line-height: 20px;
            font-size: 20px;
            padding: 4px 0;
            margin-top: 10px;
            border-radius: 5px;
            display: flex;
            justify-content: center;
            align-items: center;

            div{
                flex-grow: 1;
            }

            span {
                /*width: 10%;*/
                font-size: 15px;
                color: #999;
                text-align: center;
                margin: auto;
                /*white-space: nowrap;*/
            }
        }
    }

    .info-wrap {
        width: 100%;
        height: 90%;
        padding-bottom: 10px;
        overflow: scroll;
    }


    .next {
        height: 10%;
        color: #0082C5;
        font-size: 20px;
        margin-right: 30px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .space {
        margin-top: 30px;
    }

    input {
        border: 0;
        background: transparent;
        /*width: 100%;*/

        flex-grow: 1;
        height: 30px;
        text-indent: 10px;
        font-size: 20px;
        outline: none;
    }

    .demand-wrap{
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 10px;
    }

    textarea{
        width: 100%;
        height: 150px;

        border: 0;
        background: #D0E6F4;
        text-indent: 2px;
        font-size: 20px;
        outline: none;

    }


    label {
        width: 10px;
        height: 10px;
        border-top: 1px solid #999;;
        border-right: 1px solid #999;
        transform: rotate(45deg);
        margin-right: 10px;
    }

    .popup {
        width: 100%;
    }

    .picker-toolbar-title {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
    }

    .usi-btn-cancel,
    .usi-btn-sure {
        color: #0082C5;
    }

    .deny-wrap{
        text-align: left;
        text-indent: 0px;
        margin: 10px 10px 0px 10px;
    }

    .deny-reason{
        color: red;
        font-size: 18px;
        word-break: break-all;
        margin: 0;

    }

</style>
